import {
  PM_DASHBOARD,
  FETCH_SITES_GATES
} from "./type";

const initalState = {
  pmDashboardData: {},
  instSitesAndGates:[],
};

const pmDashboardReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PM_DASHBOARD:
      return {
        ...state,
        pmDashboardData: payload,
      };
      case FETCH_SITES_GATES:
        return {
          ...state,
          instSitesAndGates: payload,
        };
    
    default:
      return {
        ...state,
      };
  }
};

export default pmDashboardReducer;
